import React, { FunctionComponent, useEffect, useState } from "react";
import { Link, RouteComponentProps, withRouter } from "react-router-dom";
import { Guid } from "../../../api/baseApi";
import { deleteMosaic, deleteMosaicTimeslot, duplicateMosaic, getMosaicList, getMosaicTimeslots, MosaicCreateRequest, MosaicDuplicateRequest, MosaicModel, MosaicTimeslotRequest, MosaicTimeslotResponse, postMosaicTemplate, postMosaicTimeslot } from "../../../api/mosaicApi";
import { createPathWithId, Routes } from "../../../constants/routes";
import { formatDate, formatTime } from "../../../services/dateService";
import { Button } from "../../components/Button";
import { FormInput, FormInputNumber, FormRow } from "../../components/formRow/FormRow";
import GlobalSpinner from "../../components/globalsSpinner/GlobalSpinner";
import IconButton from "../../components/iconButton/IconButton";
import { CenterModal, RightModal, SmallModal } from "../../components/sideModal/Modal";
import InnerLayout from "../innerLayout/InnerLayout";
import './MosaicScreen.css' 
import Pagination from "../../components/pagination/Pagination";
import { getPagesCount } from "../../../services/paginator";

interface MosaicScreenProps extends RouteComponentProps<any>{
    logOut : () => void;
    toogleCollapse: () => void;
    isCollapsed: boolean;
}

const MosaicScreenList: FunctionComponent<MosaicScreenProps> = (props) => {
    let {logOut, toogleCollapse, isCollapsed, history} = props;

    let [mosaicList, setMosaicList] = useState<MosaicModel[]>([]);

    let [templateName, setTemplateName] = useState('');
    let [templateNameError, setTemplateNameError] = useState(false);
    let [columnNumber, setColumnNumber] = useState(1);
    let [columnNumberError, setColumnNumberError] = useState(false);
    let [rowNumber, setRowNumber] = useState(1);
    let [rowNumberError, setRowNumberError] = useState(false);

    let [isShowCreateModal, setIsShowCreateModal] = useState(false);
    let [isShowDuplicateModal, setIsShowDuplicateModal] = useState(false);
    let [duplicateId, setDuplicateId] = useState<Guid>('');
    let [duplicateName, setDuplicateName] = useState('');
    let [duplicateNameError, setDuplicateNameError] = useState(false);
    let [isShowSmallModalDeleteMosaic, setIsShowSmallModalDeleteMosaic] = useState(false);
    let [isShowScheduleModal, setIsShowScheduleModal] = useState(false);
    let [idForDelete, setIdForDelete] = useState<Guid>('');
    let [itemNameForDelete, setItemNameForDelete] = useState('');
    let [isLoading, setIsLoading] = useState(false);

    let [mosaicScheduleName, setMosaicScheduleName] = useState<JSX.Element>();
    let [isPeriodStartError, setIsPeriodStartError] = useState(false);
    let [isPeriodEndError, setIsPeriodEndError] = useState(false);
    let [periodStart, setPeriodStart] = useState('');
    let [periodEnd, setPeriodEnd] = useState('');
    let [periodName, setPeriodName] = useState('');
    let [isPeriodNameError, setIsPeriodNameError] = useState(false);
    let [currentMosaicId, setCurrentMosaicId] = useState<Guid>('');
    let [mosaicTimeslots, setMosaicTimeslots] = useState<MosaicTimeslotResponse[]>([]);

    let [currentPage, setCurrentPage] = useState(1);
    let [listItemsForDisplay,setListItemsToDisplay] = useState<MosaicModel[]>([]);
    let itemsPerPage = 10;

    useEffect(()=>{
        async function fetchData() {
            setIsLoading(true);
            await Promise.all([getMosaicListData()]);
            setIsLoading(false);
        };
        fetchData();
    },[]);

    useEffect(() => {
        let startIndex = (currentPage - 1)*itemsPerPage;
        let finishIndex = startIndex + itemsPerPage;
        setListItemsToDisplay(mosaicList.slice(startIndex, finishIndex));
    }, [mosaicList, currentPage]);

    const getMosaicListData = async () => {
        setIsLoading(true);
        let result = await getMosaicList();
        if(result.type === "succes") {
            setMosaicList(result.data.items)
        }
        setIsLoading(false);
    }

    const showCreateModal = () => {
        setIsShowCreateModal(true);
    }

    const hideCreateModal = () => {
        setIsShowCreateModal(false);
    }

    const templateNameHandler = (name: string) => {
        setTemplateNameError(false);
        setTemplateName(name)
    }

    const columnNumberHandler = (columns: number) => {
        if(columns > 0){
            setColumnNumberError(false);
            setColumnNumber(columns)
        }
    }

    const rowNumberHandler = (rows: number) => {
        if(rows > 0) {
            setRowNumberError(false);
            setRowNumber(rows)
        }
    }

    const goToCurrentMosaicScreen = (id: Guid) => {
        history.push(createPathWithId(Routes.Skins, id))
    }

    const goToCurrentSkinReport = (id: Guid) => {
        history.push(createPathWithId(Routes.ReportsSkin, id))
    }

    const saveTemplate = async () => {
        var isError = false;
        if(!templateName) { setTemplateNameError(true); isError = true; }
        if(columnNumber < 1) { setColumnNumberError(true); isError = true; }
        if(rowNumber < 1) { setRowNumberError(true); isError = true; }

        if(isError) return;

        let request: MosaicCreateRequest = {
            name: templateName,
            columnsCount: columnNumber,
            rowsCount: rowNumber,
        }
        let result = await postMosaicTemplate(request);
        if(result.type === 'succes'){
            goToCurrentMosaicScreen(result.data.id)
        }
    }

    const openDuplicateModal = (id: Guid, name: string) => {
        setDuplicateId(id);
        setDuplicateName(`${name} (Copy)`);
        setDuplicateNameError(false);
        setIsShowDuplicateModal(true);
    }

    const closeDuplicateModal = () => {
        setIsShowDuplicateModal(false);
        setDuplicateId('');
        setDuplicateName('');
        setDuplicateNameError(false);
    }

    const saveDuplicate = async () => {
        if (!duplicateName) {
            setDuplicateNameError(true);
            return;
        }

        let request: MosaicDuplicateRequest = {
            name: duplicateName
        }

        setIsLoading(true);
        let result = await duplicateMosaic(duplicateId, request);
        if (result.type === 'succes') {
            await getMosaicListData();
            closeDuplicateModal();
        }
        setIsLoading(false);
    }

    const deleteCurrentMosaicScreen = (id: Guid, name: string) => {
        setIsShowSmallModalDeleteMosaic(true);
        setIdForDelete(id);
        setItemNameForDelete(name);
    }

    const deleteMosaicConfirm = async (id: Guid) => {
        await deleteMosaic(id);
        await getMosaicListData();
        closeSmallModalMosaic();
    }

    const closeSmallModalMosaic = () => {
        setIsShowSmallModalDeleteMosaic(false);
        setIdForDelete('');
        setItemNameForDelete('');
    }

    const renderMosaicListRow = (mosaic:MosaicModel) => {
        return <tr key={mosaic.id}>
            <td>{mosaic.name}</td>
            <td>{mosaic.players.map((it,i) => <p key={i}>{it}</p>)}</td>
            <td>{mosaic.columnsCount} x {mosaic.rowsCount}</td>
            <td>
                <IconButton type="report2" tooltipText="Skin Report" onClick={() => {goToCurrentSkinReport(mosaic.id)}} />
                <IconButton type="clock" tooltipText="Schedule" onClick={() => {openScheduleModal(mosaic.name, mosaic.id)}} />
                <IconButton type="copy" tooltipText="Duplicate" onClick={()=>{openDuplicateModal(mosaic.id, mosaic.name)}}/>
                <IconButton type="edit" tooltipText="Edit" onClick={()=>{goToCurrentMosaicScreen(mosaic.id)}}/>
                <IconButton type="delete" tooltipText="Delete" onClick={()=>{deleteCurrentMosaicScreen(mosaic.id, mosaic.name)}}/>
            </td>
        </tr>
    }

    // const pageLink = (page: number, isActive: boolean) => <a key={page} className={`${isActive ? "active": ""}`} onClick={()=>{setCurrentPage(page)}} >{page}</a> 

    // const renderPagination = ( itemsPerPage: number, activeLinkNumber: number) => {
    //     let length = mosaicList.length;
    //     let pagesCount = length % itemsPerPage === 0 ? length / itemsPerPage : Math.floor(length / itemsPerPage) + 1;
    //     let links = [];
    //     for ( let i = 1; i <= pagesCount; i++) links.push(i);
    //     return <div className="pagination">
    //         {links.map(i => pageLink(i, i === activeLinkNumber))}
    //     </div>
    // }


    const openScheduleModal = async (title:string, id:Guid) => {
        setMosaicScheduleName(<><b>{`${title}`}</b> <span>schedule</span></>)
        setIsShowScheduleModal(true);
        setCurrentMosaicId(id);
        setIsLoading(true);
        await updateMosaicTimeslots(id);
        setIsLoading(false)
    }

    const closeScheduleModal = () => {
        setIsShowScheduleModal(false);
        setMosaicScheduleName(<></>);
        setCurrentMosaicId('');
        setMosaicTimeslots([]);
    }

    const setStartDatePeriod = (event: React.ChangeEvent<HTMLInputElement>) => {
        setPeriodStart(event.target.value);
        setIsPeriodStartError(false);
    }

    const setEndDatePeriod = (event: React.ChangeEvent<HTMLInputElement>) => {
        setPeriodEnd(event.target.value);
        setIsPeriodEndError(false);
    }

    useEffect(()=>{
        setIsPeriodNameError(false)
    },[periodName])

    useEffect(()=>{
        setIsPeriodStartError(false);
        setIsPeriodEndError(false)
    },[periodStart, periodEnd])

    const saveTimeslot = async () => {
        let isError = false;
        if(periodName === '') {
            setIsPeriodNameError(true);
            isError = true
        }

        if(periodStart === ''){
            setIsPeriodStartError(true)
            isError = true
        }

        if(periodEnd === ''){
            setIsPeriodEndError(true)
            isError = true
        }

        if(new Date(periodEnd) <= new Date(periodStart)){
            setIsPeriodEndError(true);
            isError = true
        }
        if(isError) return

        let request:MosaicTimeslotRequest = {
            name: periodName,
            start: periodStart,
            end: periodEnd 
        }

        setIsLoading(true);
        let result = await postMosaicTimeslot(request, currentMosaicId);
        if(result.type === "succes") {
            await updateMosaicTimeslots(currentMosaicId);
        }
        setPeriodName('');
        setPeriodStart('');
        setPeriodEnd('');
        setIsLoading(false);
    }

    const removeTimeslot = async (mosaicId:Guid, slotId:Guid) => {
        setIsLoading(true)
        await deleteMosaicTimeslot(mosaicId,slotId);
        await updateMosaicTimeslots(mosaicId);
        setIsLoading(false);
    }

    const updateMosaicTimeslots = async (mosaicId:Guid) => {
        let result = await getMosaicTimeslots(mosaicId);
        if(result.type === "succes") {
            setMosaicTimeslots(result.data.items.sort((a,b)=>{
                return new Date(a.start).getTime() - new Date(b.start).getTime()
            }))
        }
    }

    const renderTimeslotRow = (timeslots: MosaicTimeslotResponse[]) => {
        return timeslots.map( it => {
            return <tr key={it.id}>
                <td>{it.name}</td>
                <td>{formatDate(it.start)} {formatTime(it.start)}</td>
                <td>{formatDate(it.end)} {formatTime(it.end)}</td>
                <td>
                    <IconButton type="delete" tooltipText="Delete" onClick={()=>{removeTimeslot(currentMosaicId, it.id)}}/>
                </td>
            </tr>
        })
    }

    return <InnerLayout 
        activeTab="skins" 
        logOut={logOut} 
        toogleCollapse={toogleCollapse}
        isCollapsed={isCollapsed}
        >
            <>  
                <div className="d-flex justify-content-between align-items-center mb-20 pt-50">
                    <div className="d-flex gap15">
                        <Link to={Routes.ReportsSkin}>
                            <span className="report-link-text">Skin report</span>
                        </Link>
                        <Link to={Routes.ReportsSkinAdhoc}>
                            <span className="report-link-text">Skin Adhoc report</span>
                        </Link>
                    </div>
                    <Button color="green"  label="Add Skin" onClick={showCreateModal} />
                </div>

                <table className="table">
                    <thead>
                        <tr>
                            <td>Name</td>
                            <td>Players</td>
                            <td>Grid Dimension</td>
                            <td></td>
                        </tr>
                    </thead>
                    <tbody>
                        {listItemsForDisplay.map( it => renderMosaicListRow(it))}
                    </tbody>                        
                </table>

                <Pagination activePage={currentPage} pagesCount={getPagesCount(mosaicList.length, itemsPerPage)} changePaginationPage={setCurrentPage} />

                <RightModal  title="Add Skin" show={isShowCreateModal} onRequestClose={hideCreateModal} >
                    <FormRow>
                        <FormInput 
                            errorMessage = "Please enter name"
                            id = "template_name"
                            isError = {templateNameError}
                            title = "Skin Name"
                            onChange = {(e)=>{templateNameHandler(e.target.value)}}
                            value = {templateName}
                        />
                    </FormRow>
                    <FormRow>
                        <FormInputNumber 
                            errorMessage = "Please enter positive column number"
                            id = "column_number_input"
                            isError = {columnNumberError}
                            title = "Column Number"
                            onChange = {(e)=>{columnNumberHandler(+e.target.value)}}
                            value = {columnNumber}
                        />
                    </FormRow>
                    <FormRow>
                        <FormInputNumber 
                            errorMessage = "Please enter positiv row number"
                            id = "row_number_input"
                            isError = {rowNumberError}
                            title = "Row Number"
                            onChange = {(e)=>{rowNumberHandler(+e.target.value)}}
                            value = {rowNumber}
                        />
                    </FormRow>
                    <div className="modal-btn-group">
                        <Button color="green" label="Save" onClick={saveTemplate}/>
                        <Button color="gray" label="Cancel" onClick={hideCreateModal}/>
                    </div>
                </RightModal> 
                <CenterModal title={mosaicScheduleName} show={isShowScheduleModal} onRequestClose={closeScheduleModal}>
                    <div className="mosaic-period-wrapper">
                        <div className="mosaic-period-inputs">
                            <div>
                                <FormInput 
                                    errorMessage = "Please enter name"
                                    id = "period_name"
                                    isError = {isPeriodNameError}
                                    title = "Name"
                                    onChange = {(e)=>{setPeriodName(e.target.value)}}
                                    value = {periodName}
                                />
                            </div>
                            <div className="">
                                <label htmlFor="start">Start</label>
                                <input 
                                    type="datetime-local" 
                                    className={`form-control ${isPeriodStartError ? "error" : ""}`}  
                                    name="" 
                                    id="start" 
                                    onChange={setStartDatePeriod}
                                    value={periodStart}
                                />
                                {isPeriodStartError && <span className="error">Please select start period</span>}
                            </div>
                            <div className="">
                                <label htmlFor="ends">End</label>
                                <input 
                                    type="datetime-local" 
                                    className={`form-control ${isPeriodEndError ? "error" : ""}`}  
                                    name="" 
                                    id="ends" 
                                    onChange={setEndDatePeriod}
                                    value={periodEnd}
                                    min={periodStart}
                                    disabled={!!!periodStart}
                                />
                                {isPeriodEndError && <span className="error">End period should be later than start period</span>}
                            </div>
                            <div className="">
                                <Button color="green" label="Add" onClick={saveTimeslot}/>
                            </div>
                        </div>
                        <table className="table">
                            <thead>
                                <tr>
                                    <td>Name</td>
                                    <td>Start</td>
                                    <td>End</td>
                                    <td></td>
                                </tr>
                            </thead>
                            <tbody>
                                {renderTimeslotRow(mosaicTimeslots)}
                            </tbody>
                        </table>
                    </div>
                </CenterModal>
                <RightModal title="Duplicate Skin" show={isShowDuplicateModal} onRequestClose={closeDuplicateModal}>
                    <FormRow>
                        <FormInput 
                            errorMessage = "Please enter name"
                            id = "duplicate_name"
                            isError = {duplicateNameError}
                            title = "Skin Name"
                            onChange = {(e)=>{setDuplicateName(e.target.value); setDuplicateNameError(false);}}
                            value = {duplicateName}
                        />
                    </FormRow>
                    <div className="modal-btn-group">
                        <Button color="green" label="Save" onClick={saveDuplicate}/>
                        <Button color="gray" label="Cancel" onClick={closeDuplicateModal}/>
                    </div>
                </RightModal>
                <SmallModal show={isShowSmallModalDeleteMosaic} onRequestClose={closeSmallModalMosaic}> 
                    <p>That you want to delete list <b>{itemNameForDelete}</b>?</p>
                    <div className="modal-btn-group">
                        <Button color="gray" label="Cancel" onClick={closeSmallModalMosaic}/>
                        <Button color="green" label="Yes" onClick={()=>deleteMosaicConfirm(idForDelete)}/>
                    </div>
                </SmallModal>  
                <GlobalSpinner isShow={isLoading} />
            </>
    </InnerLayout>
}

export default withRouter(MosaicScreenList);